import "./AdsPrerollLoader.css";
import { formatPercent, interpolateProgress, ringDashOffset, } from "./prerollProgress";
const SVG_NS = "http://www.w3.org/2000/svg";
// raggio dell'anello nel viewBox 64x64 e relativa circonferenza
const RING_RADIUS = 26;
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;
export class AdsPrerollLoader {
    constructor(playerElement, options) {
        this.progress = 0;
        this.animationFrame = null;
        this.reduceMotion =
            window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false;
        this.root = document.createElement("div");
        this.root.id = "prerollLoader";
        this.root.className = "preroll-loader";
        this.root.hidden = true;
        this.root.setAttribute("role", "status");
        if (options.posterUrl) {
            const poster = document.createElement("div");
            poster.className = "preroll-loader__poster";
            // escape solo di virgolette e backslash: encodeURI ricodificherebbe i %xx gia' presenti (token CDN)
            const cssUrl = options.posterUrl.replace(/["\\]/g, "\\$&");
            poster.style.backgroundImage = `url("${cssUrl}")`;
            this.root.appendChild(poster);
        }
        const center = document.createElement("div");
        center.className = "preroll-loader__center";
        const ringWrap = document.createElement("div");
        ringWrap.className = "preroll-loader__ring-wrap";
        const ring = document.createElementNS(SVG_NS, "svg");
        ring.setAttribute("class", "preroll-loader__ring");
        ring.setAttribute("viewBox", "0 0 64 64");
        ring.setAttribute("aria-hidden", "true");
        const track = this.createCircle("preroll-loader__track");
        this.fill = this.createCircle("preroll-loader__fill");
        // Tratteggio e offset come attributi SVG numerici, aggiornati da JS: la versione CSS con
        // calc() e var() su Firefox veniva scartata e l'anello restava sempre pieno
        this.fill.setAttribute("stroke-dasharray", String(RING_CIRCUMFERENCE));
        ring.append(track, this.fill);
        this.percent = document.createElement("span");
        this.percent.className = "preroll-loader__percent";
        ringWrap.append(ring, this.percent);
        center.appendChild(ringWrap);
        const title = document.createElement("p");
        title.className = "preroll-loader__title";
        title.textContent = options.title;
        center.appendChild(title);
        if (options.subtitle) {
            const subtitle = document.createElement("p");
            subtitle.className = "preroll-loader__subtitle";
            subtitle.textContent = options.subtitle;
            center.appendChild(subtitle);
        }
        this.root.appendChild(center);
        playerElement.appendChild(this.root);
        this.render(0);
    }
    /**
     * Mostra il loader con l'anello vuoto
     */
    show() {
        this.setProgress(0, 0);
        this.root.hidden = false;
    }
    hide() {
        this.stopAnimation();
        this.root.hidden = true;
    }
    /**
     * Porta anello e percentuale a value (0-1) in durationMs.
     * Durante un VAST uso una durata lunga verso la fine dello step: l'anello avanza piano anche
     * mentre si aspetta la risposta, cosi' un VAST lento non sembra un blocco.
     */
    setProgress(value, durationMs) {
        this.stopAnimation();
        const from = this.progress;
        const duration = this.reduceMotion ? 0 : durationMs;
        if (duration <= 0) {
            this.render(value);
            return;
        }
        const startedAt = performance.now();
        const step = (now) => {
            this.render(interpolateProgress(from, value, now - startedAt, duration));
            if (now - startedAt < duration) {
                this.animationFrame = requestAnimationFrame(step);
            }
            else {
                this.animationFrame = null;
            }
        };
        this.animationFrame = requestAnimationFrame(step);
    }
    destroy() {
        this.stopAnimation();
        this.root.remove();
    }
    render(progress) {
        this.progress = progress;
        this.fill.setAttribute("stroke-dashoffset", String(ringDashOffset(progress, RING_CIRCUMFERENCE)));
        this.percent.textContent = formatPercent(progress);
    }
    stopAnimation() {
        if (this.animationFrame !== null) {
            cancelAnimationFrame(this.animationFrame);
            this.animationFrame = null;
        }
    }
    createCircle(className) {
        const circle = document.createElementNS(SVG_NS, "circle");
        circle.setAttribute("class", className);
        circle.setAttribute("cx", "32");
        circle.setAttribute("cy", "32");
        circle.setAttribute("r", String(RING_RADIUS));
        return circle;
    }
}
